import { SagaIterator } from "redux-saga";
import { CreateFundingDetailsRequest, FundingDetailsReduxTypes } from "./types";
import { call, fork, put, takeEvery } from "redux-saga/effects";
import { createFundingDetailsApi } from "./api";

function* createFundingDetails({ payload }: CreateFundingDetailsRequest): SagaIterator {
    try {
        const response = yield call(createFundingDetailsApi, payload);
        yield put({
            type: FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT_ERROR,
            payload: { error: error }
        })
    }
}

export function* watchCreateFunctionDetails() {
    yield takeEvery(FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT, createFundingDetails)
}

function* fundingDetailsSaga() {
    yield fork(watchCreateFunctionDetails)
}

export default fundingDetailsSaga